import { ArsTableState } from "../interface";

/**
 * Toggles sidebar visibility.
 *
 * @param state - Current ARS table state
 * @returns Updated ARS table state
 */
export const arst_toggleSidebar = <T>(state: ArsTableState<T>): ArsTableState<T> => ({
  ...state,
  settings: {
    ...state.settings,
    showSidebar: !state.settings.showSidebar,
  },
});
